import React, { useContext, useState } from "react";
import { SetupDataPageTemplate } from "../../../components/setup-pages/SetupDataPageTemplate";
import { setupData } from "../../../configs/routes";
import { pathRoot, schema, getOptionsElements } from "../Compensation";
import { Form } from "react-jsonschema-form-validation";
import { DiseaseGroupContext } from "../../../contexts/diseaseGroupContext";

//if page 1 is No
export const Page2 = ({ compensation, handleSave }) => {
	const options = [
		{
			label: "Because I chose not to",
			value: 0,
		},
		{
			label: "Because I didn't know I could",
			value: 1,
		},
		{
			label: "Because there was not enough evidence to pursue a case",
			value: 2,
		},
	];

	const [whyNot, setWhyNot] = useState(compensation.whyNot);

	const { theme } = useContext(DiseaseGroupContext);

	const onNext = () => {
		return new Promise((resolve, reject) => {
			compensation.whyNot = whyNot;
			handleSave(compensation).then(resolve).catch(reject);
		});
	};

	const headerDetails = {
		title: "Compensation",
		currentPage: 2,
		pageCount: 4,
	};

	return (
		<SetupDataPageTemplate
			headerDetails={headerDetails}
			backTo={`${pathRoot}/1`}
			nextTextOverride={"Finish"}
			nextTo={setupData}
			onClickNext={{ async: true, func: onNext }}
			hideNext={whyNot === null}
		>
			<Form schema={schema}>
				<p className={"text-lg sm:text-xl font-bold mb-6"}>If NO why not?</p>
				<div>
					{getOptionsElements(options, "whyNot", whyNot, setWhyNot, theme)}
				</div>
			</Form>
		</SetupDataPageTemplate>
	);
};
